import classNames from "classnames";
import React, { InputHTMLAttributes } from "react";
import { RadioProps } from "@common/types";
import { Text } from "../text";
import { variants } from "./CheckBox";

export const Radio = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> &
    RadioProps & {
      inputClassName?: string;
    }
>(function Radio(
  { label, className, block, hint, error, inputClassName, success, ...props },
  ref,
) {
  const errorMessage = error
    ? typeof error === "string"
      ? error
      : typeof error === "object"
        ? error.message
        : false
    : false;

  const variant = error
    ? "danger"
    : success
      ? "success"
      : props.disabled
        ? "disabled"
        : "default";

  return (
    <div className={block ? "flex" : "inline-flex"}>
      <label
        className={classNames(
          block ? "flex" : "inline-flex",
          "min-h-10 items-center py-2 md:min-h-0 md:py-0",
          className,
        )}
      >
        <input
          type="radio"
          className={classNames(
            "h-4 w-4 border shadow-none transition-colors focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-100",
            variants[variant],
            inputClassName,
          )}
          ref={ref}
          {...props}
        />
        {label && (
          <Text variant={variant} className="me-3 ms-2 font-medium">
            {label}
          </Text>
        )}
      </label>
      {hint && <Text variant="muted">{hint}</Text>}
      {errorMessage ? (
        <Text variant="danger" className="mt-2 text-xs">
          {errorMessage}
        </Text>
      ) : success ? (
        <Text variant="success" className="mt-2 text-xs">
          {success}
        </Text>
      ) : null}
    </div>
  );
});
